import {
	experienceManifestId,
	type ExperienceManifestId,
} from '@atlassian/native-embeds-core/types';

export const AVPVIZ_EXPERIENCE_MANIFEST_ID: ExperienceManifestId = experienceManifestId('avpviz');
